import IndexedDB from '@/helpers/IndexedDB.js';

import store from '@/store';


const Observable = () => {
	const idForm = store.state.resource.idForm;
	const idPage = store.state.resource.idPage;
	const idDependence = store.state.resource.idDependence
	const idCounter = store.state.resource.idCounter;
	const questionsByPage = store.state.resource.questionsByPage;
	const counter = store.state.resource.counter;

	return {idForm, idPage, idCounter, questionsByPage, counter, idDependence};
}

const createDependence = async (nameDad, nameChild, related) => {	
	const { idDependence } = Observable();
	const result = await getDependencies();
	const { simple, dependencias } = result;
	let _simple = { ...simple };
	let _dependencies = [...dependencias, nameChild];
	
	if(simple[nameDad] !== undefined && simple[nameDad] !== null) {
		//SE ACTUALIZA EL OBJETO AGREGANDO EL HIJO	
		_simple[nameDad][nameChild] = related;
	}else {
		//SE CREA EL OBJETO		
		_simple[nameDad] = {
			[nameChild]: related
		}	
	}	
	await IndexedDB.update('dependencias', { dependencias: _dependencies, simple: _simple }, idDependence);
}

const createDependenceListener = async (nameQuestion, related) => {
	const { idDependence } = Observable();
	const result = await getDependencies();	
	const { listener, dependencias } = result;
	let _dependencies = [];
	if(!dependencias.includes(nameQuestion)) _dependencies = [...dependencias, nameQuestion];
	else _dependencies = [...dependencias];
	 	
	const newData = {
		[nameQuestion]: {
			related
		}
	}
	const _listener = { ...listener, ...newData };
	await IndexedDB.update('dependencias', { dependencias: _dependencies, listener: _listener }, idDependence);
}

const createDependenceCompound = async (nameQuestion, related) => {
	const { idDependence } = Observable();
	const result = await getDependencies();	
	const { compound, dependencias } = result;

	let _dependencies = [];
	if(!dependencias.includes(nameQuestion)) _dependencies = [...dependencias, nameQuestion];
	else _dependencies = [...dependencias];

	const newData = {
		[nameQuestion]: related
	}

	const _compound = { ...compound, ...newData };	
	await IndexedDB.update('dependencias', { dependencias: _dependencies, compound: _compound }, idDependence);
}

const getDependencies = async () => {
	const { idForm } = Observable();
	const result = await  IndexedDB.where_('dependencias',{"id_form": idForm}, {query: 'first'});	
	const { simple, dependencias, listener, compound , key } = result;
	return { simple, dependencias, listener, compound, key } 
}


const getListener = async () => {
	const { idForm } = Observable();
	const result = await  IndexedDB.where_('dependencias',{"id_form": idForm}, {query: 'first'});
	const { listener, dependencias } = result;
	return { listener, dependencias }
}

const deleteDependenceDad = async (nameQuestion) => {	//CUANDO ELIMINO UNA PREGUNTA DEL FORMULARIO
	const { idDependence } = Observable();	
	const result = await getDependencies();
	const {simple, compound, dependencias } = result;

	const children = await getChildrenDependence(nameQuestion, simple);
	const newDependencies = dependencias.filter(child => !children.includes(child) && child !== nameQuestion);
	let newCreated = {...simple};
	delete newCreated[nameQuestion];

	let newCompound = {...compound};
	delete newCompound[nameQuestion];
	await IndexedDB.update('dependencias', { dependencias: newDependencies, simple: newCreated, compound: newCompound }, idDependence);
}

const deleteDependenceChild = async (nameQuestionDad, nameQuestionChild) => { //CUANDO DESVINCULO UNA PREGUNTA HIJA DEL PADRE
	const { idDependence } = Observable();	
	const result = await getDependencies();
	const {simple, dependencias } = result;

	if(Object.entries(simple).length > 0) {
		const newDependencies = dependencias.filter(child => child !== nameQuestionChild);

		let newCreated = {...simple};
		delete newCreated[nameQuestionDad][nameQuestionChild];
		if(Object.entries(newCreated[nameQuestionDad]).length === 0) delete newCreated[nameQuestionDad];		
		await IndexedDB.update('dependencias', { dependencias: newDependencies, simple: newCreated }, idDependence);				
	}	
}

const deleteItemFromDependencies = async (nameQuestion) => {
	const { idDependence } = Observable();	
	const result = await getDependencies();
	const { dependencias } = result;

	const newDependencies = dependencias.filter(child => child !== nameQuestion);
	await IndexedDB.update('dependencias', { dependencias: newDependencies }, idDependence);
}

const deleteListener = async (nameQuestion) => {
	const { idDependence } = Observable();	
	const result = await getDependencies();
	const {listener, dependencias } = result;

	const newDependencies = dependencias.filter(child => child !== nameQuestion); 
	let newListener = {...listener};
	delete newListener[nameQuestion];

	await IndexedDB.update('dependencias', { dependencias: newDependencies, listener: newListener }, idDependence);
}

const deleteCompound = async (nameQuestionDad, nameChild) => {
	const { idDependence } = Observable();

	const { compound, dependencias } = await getDependencies();	

	if(compound[nameQuestionDad] === undefined) return;

	const { answers } = compound[nameQuestionDad];
	const deleteQuestion = answers.filter(question => question.name !== nameChild);
	let newDependencies = [...dependencias];
	if(deleteQuestion.length === 0) {
		delete compound[nameQuestionDad];
		newDependencies = dependencias.filter(name => name !== nameQuestionDad);
	} 
	else compound[nameQuestionDad].answers = deleteQuestion;

	await IndexedDB.update('dependencias', { dependencias: newDependencies, compound: compound }, idDependence);
}

const getChildrenDependence = async (nameQuestion, simpleParams = null) => {	
	const { idForm } = Observable();
	let simple = simpleParams;

	if(simple === null) {
		const result = await  IndexedDB.where_('dependencias',{"id_form": idForm}, {query: 'first'});
		simple = result.simple;
	}

	if(Object.entries(simple).length > 0) {
		if(simple[nameQuestion]) {			
			return Object.keys(simple[nameQuestion]);
		}
	}
	return [];
}

const updateDependecies = async (simple, compound, listener) => {
	const { idDependence } = Observable();
	await IndexedDB.update('dependencias', { simple: simple, compound: compound, listener: listener }, idDependence);
}

const getDadQuestion = async (nameQuestion) => {
	const { simple } = await getDependencies();	
	let Dad = null;
	for(var i in simple) {
		if(simple[i][nameQuestion]) {
			Dad = i;
			break;
		} 
	}

	return Dad;
}

export {
	createDependence,
	createDependenceListener,
	createDependenceCompound,
	getDependencies,
	getListener,	
	getChildrenDependence,
	getDadQuestion,
	deleteDependenceDad,
	deleteDependenceChild,
	deleteListener,
	deleteCompound,
	deleteItemFromDependencies,
	updateDependecies		
}